import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { AbstractControl, ValidationErrors, ValidatorFn, Validators, ReactiveFormsModule } from '@angular/forms';
import { isNil, isNumber } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormNumberBaseComponent } from '../base-simple/form-number-base.component';
import { ShFormNumberComplexBaseComponent } from '../base-complex/form-number-complex-base.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-number-input',
    templateUrl: './form-number.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, NgIf, ShFormNumberComplexBaseComponent, ReactiveFormsModule, NgClass, ShFormNumberBaseComponent, AsyncPipe]
})
export class ShFormNumberInputComponent extends ShBaseFormComponent implements OnInit {
    @Input() placeholder?: string;
    @Input() min: number = Number.MIN_SAFE_INTEGER;
    @Input() max: number = Number.MAX_SAFE_INTEGER;
    @Input() step = 1;

    public innerErrorMessage$: BehaviorSubject<string> = new BehaviorSubject('');

    public ngOnInit(): void {
        super.ngOnInit();

        this.control.addValidators([this.minValidator, this.maxValidator]);
        this.control.updateValueAndValidity();

        this.control.valueChanges.subscribe(_ => {
            if (this.control.getError('min')) {
                this.innerErrorMessage$.next(this.translateService.instant('errors.min', { limit: this.min }));
            } else if (this.control.getError('max')) {
                this.innerErrorMessage$.next(this.translateService.instant('errors.max', { limit: this.max }));
            } else {
                this.innerErrorMessage$.next('');
            }
        });
    }

    private get minValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (isNil(control.value)) {
                return null;
            }
            if (isNumber(control.value)) {
                return Validators.min(this.min)(control);
            }

            return !control.value.value || control.value.value > this.min
                ? null
                : { min: this.min, actual: control.value.value };
        };
    }

    private get maxValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (isNil(control.value)) {
                return null;
            }
            if (isNumber(control.value)) {
                return Validators.max(this.max)(control);
            }

            return control.value.value < this.max ? null : { max: this.max, actual: control.value };
        };
    }
}
